<!-- Footer HTML -->
<div class="main-container">
  <div class="footer-layout">
    <!-- LEFT: Download buttons -->
    <div class="left-section">
      <div class="button-container">
        <a (click)="downloadPdf()" class="download-button" download>
          <img src="assets/pdf.png" alt="PDF" class="pdf-icon">
          <span>ΚΥΑ-Οδηγός</span>
        </a>
        <a (click)="downloadPdf2()" class="download-button" download>
          <img src="assets/pdf.png" alt="PDF" class="pdf-icon">
          <span>Ερωτήσεις-Απαντήσεις</span>
        </a>
      </div>
    </div>
    
    <!-- MIDDLE: Logos -->
    <div class="middle-section">
      <div class="logos-container">

           <div class="logo ypen-logo">
          <img src="assets/ypen.png" alt="Ypen logo">
        </div>
        <div class="logo deddie-logo">
          <img src="assets/deddie-logo.svg" alt="Deddie logo">
        </div>
     
      </div>
    </div>
    
    <!-- RIGHT: Support button and Privacy Policy button -->
    <div class="right-section">
      <div class="right-buttons">
        <button class="support-button" (click)="toggleSupportModal()">
          <span>Υποστήριξη</span>
          <mat-icon>contact_support</mat-icon>
        </button>
        <a (click)="downloadPrivacyPdf()" class="privacy-button" download>
          <span>Όροι Χρήσης και Ενημέρωση</span>
          <img src="assets/pdf.png" alt="PDF" class="pdf-icon">
        </a>
      </div>
    </div>
  </div>
</div>

<!-- Support Modal -->
<div id="supportModal" class="modal" [ngClass]="{'show-modal': showModal}">
  <div class="modal-content">
    <span class="close-button" (click)="toggleSupportModal()">&times;</span>
    <p style="font-size: 22px;">ΥΠΟΣΤΗΡΙΞΗ ΔΕΔΔΗΕ Power4Business<p>
    <div class="support-info">
      <p><strong>Τηλέφωνο:</strong> 2106292320</p>
     <p><strong>Ωράριο:</strong> Δευτέρα – Παρασκευή, 09.00 – 17.00, εκτός αργιών</p>
    </div>
  </div>
</div>